import React from "react";
import NotFoundComponent from "../components/NotFound";

const NotFound = () => {
  return <NotFoundComponent />;
};

export default NotFound;
